module.exports = __webpack_public_path__ + "img/Paladin-dwarf-f-60.e8a6ca8e.gif";